export const DATE_FORMAT = 'DD-MM-YYYY'
export const WESTPARK = 'WESTPARK'

export const CURRENT_COUNTRY_CANADA = 'CA'
export const CUSTOMER_TYPE_INDIVIDUAL = 'CPF'
export const CUSTOMER_TYPE_BUSINESS = 'CNPJ'

export const CUSTOMER_TYPE_CO_CITIZEN = 'CC'
export const CUSTOMER_TYPE_CO_FOREIGNER = 'CE'
export const CUSTOMER_TYPE_CO_BUSINESS = 'NIT'
